import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, setToken, getDeviceId } from "../lib/api";

export default function Auth() {
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) return;
    setBusy(true);
    try {
      const url = mode === "login" ? "/auth/login" : "/auth/signup";
      const body = { email, password };
      if (mode === "signup") body.device_id = getDeviceId();
      const { data } = await api.post(url, body);
      setToken(data.token);
      toast.success(mode === "login" ? "Welcome back!" : "Account created");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Something went wrong");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="px-6 pt-6 pb-8" data-testid="auth-page">
      <div className="mm-card">
        <div className="mm-label mb-2">Account</div>
        <h1 className="text-2xl font-extrabold text-slate-900 tracking-tight mb-1">
          {mode === "login" ? "Log in" : "Create an account"}
        </h1>
        <p className="text-sm text-slate-500 mb-5">
          {mode === "login"
            ? "Access your saved analyses and scan credits."
            : "Save your scans and never lose an analysis."}
        </p>

        <form onSubmit={submit} className="space-y-3">
          <div>
            <label className="mm-label block mb-2">Email</label>
            <input
              type="email"
              className="mm-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
              data-testid="auth-email-input"
            />
          </div>
          <div>
            <label className="mm-label block mb-2">Password</label>
            <input
              type="password"
              className="mm-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete={mode === "login" ? "current-password" : "new-password"}
              minLength={6}
              required
              data-testid="auth-password-input"
            />
          </div>

          <button
            type="submit"
            className="mm-btn-primary !h-14 !text-base"
            disabled={busy}
            data-testid="auth-submit-btn"
          >
            {busy ? "Please wait…" : mode === "login" ? "Log in" : "Create account"}
          </button>
        </form>

        <button
          type="button"
          className="mt-4 text-sm text-blue-700 font-bold w-full text-center"
          onClick={() => setMode(mode === "login" ? "signup" : "login")}
          data-testid="auth-switch-btn"
        >
          {mode === "login"
            ? "New here? Create an account"
            : "Already have an account? Log in"}
        </button>
      </div>
    </div>
  );
}
